module.exports = __webpack_public_path__ + "static/media/icon_sounds.102c6996.svg";